import { useLocation, useResolvedPath } from 'react-router-dom'

export default function useIsCurrentLink(pathname: string) {
	const resolved = useResolvedPath(pathname)
	const { pathname: currentPathname } = useLocation()

	const base = resolved.pathname

	let isCurrent = false

	if (base === '/') {
		isCurrent = currentPathname === '/'
	} else {
		isCurrent =
			currentPathname === base || currentPathname.startsWith(`${base}/`)
	}

	return { isCurrent }
}
